import Ajax from '../../../../common/js/Ajax.js';
import Dialog from '../../../../common/js/dialog/Dialog.js';
import Widget from '../../../../common/js/Widget.js';
import WidgetLoader from '../../../../common/js/WidgetLoader.js';

import TEMPLATE from './ExportWidget.hbs';

export default class TasksWidget extends Widget {
	constructor($widget) {
		super($widget);

		Ajax.rpc(
			'/isLoggedIn',
			loggedIn => {
				if (loggedIn) {
					this.show();
					this.updateDays();
					window.setInterval(() => this.updateRunningClock(), 10000);
				} else {
					window.location.href = '/login';
				}
			},
			error => {
				this.show();
				MessageUtils.error($widget, 'Fehler beim Überprüfen des Logins', error);
			}
		);
	}

	updateDays(callback) {
		const widget = this;

		Ajax.rpc('/projects', response => {
			const {projects} = response;
			this.projects = projects;

			const days = {};
			let hasClocks = false;
			for (const project of projects) {
				for (var task of project.tasks) {
					for (var clock of task.clocks) {
						const dateString = clock.day.toString('yyyyMMdd');
						const today = dateString === new Date().toString('yyyyMMdd');
						if (clock.seconds < 30 && !(today && task.running)) {
							continue;
						}

						let day = days[clock.day];
						if (!day) {
							day = {date: clock.day, dateString, firstStartTime: null, lastStopTime: null, projects: {}};
							days[clock.day] = day;
						}

						if (!day.firstStartTime || clock.firstStartTime && clock.firstStartTime < day.firstStartTime) {
							day.firstStartTime = clock.firstStartTime;
						}
						if (!day.lastStopTime || clock.lastStopTime && clock.lastStopTime > day.lastStopTime) {
							day.lastStopTime = clock.lastStopTime;
						}

						let dayProject = day.projects[project.id];
						if (!dayProject) {
							dayProject = {project, tasks: []};
							day.projects[project.id] = dayProject;
						}

						dayProject.tasks.push({
							id: task.id,
							name: task.name,
							seconds: clock.seconds,
							running: today && task.running,
						});
						hasClocks = true;
					}
				}
			}

			widget.days = Object.values(days);
			widget.days.sort((day1, day2) => day2.date.getTime() - day1.date.getTime());
			widget.days.forEach(day => (day.projects = Object.values(day.projects)));

			this.$widget.html(TEMPLATE({days: widget.days, hasClocks}));
			this.updateClockTimes();
			WidgetLoader.initialize();

			$('.js_day-delete').click(function () {
				Dialog.question(
					'Clear times',
					'Are you sure to delete all tracked times of this day?',
					true,
					'Delete clocks',
					() => {
						const dayString = $(this).closest('.js_day').attr('data-day');
						const day = Date.parseExact(dayString, 'yyyyMMdd');
						widget.setSaving(true);
						Ajax.rpc('/clearDayClocks', {day}, () => {
							widget.updateDays();
							widget.setSaving(false);
						});
					}
				);
			});

			$('.project__copy-time').click(function () {
				const hours = $(this).closest('.js_project-name').find('.js_project-day-clock-summary').attr('data-hours');
				navigator.clipboard.writeText(hours);
			});

			$('.project__copy-name').click(function () {
				const projectId = $(this).closest('.js_project-name').attr('data-project');
				let taskTimes = [];
				$(this)
					.closest('.js_day')
					.find('.js_tasks[data-project="' + projectId + '"] .task')
					.each(function () {
						console.log('x');
						const taskName = $(this).find('.task__name__output').text().replace(/^#([^ ]+).*$/, '$1');
						const hours = $(this).find('.task__time__output').attr('data-hours');
						taskTimes.push(`${taskName}:${hours}`);
					});
				navigator.clipboard.writeText(taskTimes.join('; '));
			});

			$('.task__copy-time').click(function () {
				const hours = $(this).closest('.task').find('.task__time__output').attr('data-hours');
				navigator.clipboard.writeText(hours);
			});

			$('.task__copy-name').click(function () {
				const taskName = $(this).closest('.task').find('.task__name__output').text();
				navigator.clipboard.writeText(taskName);
			});

			if (callback) {
				callback();
			}
		});
	}

	updateClockTimes() {
		this.days.forEach(day => {
			const $day = $('.section[data-day="' + day.dateString + '"]');
			let dayMinutes = 0;
			day.projects.forEach(dayProject => {
				const {project, tasks} = dayProject;
				const $project = $day.find('.js_tasks[data-project="' + project.id + '"]');

				let projectDayMinutes = 0;
				tasks.forEach(task => {
					const $task = $project.find('.task[data-id="' + task.id + '"]');
					const $taskTime = $task.find('.task__time__output');
					const minutes = Math.round(task.seconds / 60);
					projectDayMinutes += minutes;
					dayMinutes += minutes;
					$taskTime.html(this.formatMinutes(minutes));
					$taskTime.attr('data-hours', this.formatHours(task.seconds));
				});

				const $projectDayMinutes = $day.find(
					'.js_project-name[data-project="' + project.id + '"] .js_project-day-clock-summary'
				);
				$projectDayMinutes.text(this.formatMinutes(projectDayMinutes));
				$projectDayMinutes.attr('data-hours', this.formatHours(projectDayMinutes * 60));
			});
			let daySummary = `Sum: ${this.formatMinutes(dayMinutes)}`

			const firstStartTime = this.parseTime(day.firstStartTime);
			const lastStopTime = this.parseTime(day.lastStopTime);
			if (firstStartTime) {
				daySummary += `, begin: ${this.formatTime(firstStartTime)}`
				if (lastStopTime) {
					daySummary += `, end: ${this.formatTime(lastStopTime)}`
					const workingTimeMinutes = lastStopTime ? Math.round((lastStopTime - firstStartTime) / 60) : 0;
					if (workingTimeMinutes - dayMinutes >= 5) {
						daySummary += `, pauses: ${this.formatTime((workingTimeMinutes - dayMinutes) * 60)}`
					}
				}
			}

			const $daySummary = $day.find('.js_day-clock-summary');
			$daySummary.text(daySummary);
		});
	}

	updateRunningClock() {
		this.days.forEach(day => {
			day.projects.forEach(dayProject => {
				dayProject.tasks.forEach(task => {
					if (task.running) {
						task.seconds += 10;
						this.updateClockTimes();
						return;
					}
				});
			});
		});
	}

	formatMinutes(minutes) {
		if (minutes <= 0) {
			return '';
		}

		const hours = Math.floor(minutes / 60);
		minutes -= hours * 60;

		return (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes;
	}

	formatHours(seconds) {
		const quarters = Math.round(seconds / 60 / 15);
		const hours = Math.floor(quarters / 4);
		const fraction = quarters - hours * 4;
		return `${hours}${['', '.25', '.5', '.75'][fraction]}`;
	}

	formatTime(seconds) {
		const totalMinutes = Math.round(seconds / 60)
		const hours = Math.floor(totalMinutes / 60);
		const minutes = totalMinutes - hours * 60;
		return `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
	}

	parseTime(timeString) {
		if (!timeString || !timeString.match(/^[0-9]{6}$/)) {
			return null
		}

		return parseInt(timeString.substring(0, 2), 10) * 3600
			+ parseInt(timeString.substring(2, 4), 10) * 60
			+ parseInt(timeString.substring(4, 6), 10);
	}

	setSaving(saving) {
		$('.saving').remove();
		if (saving) {
			$('#page').append('<div class="saving"></div>');
		}
	}
}
